import script from "./Collaborators.vue?vue&type=script&setup=true&lang=js"
export * from "./Collaborators.vue?vue&type=script&setup=true&lang=js"

import "./Collaborators.vue?vue&type=style&index=0&id=923420c4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-923420c4"]])

export default __exports__